'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getDataTableApi = getDataTableApi;
function getDataTableApi(innerElement) {
	return $(innerElement).closest('.dataTables_wrapper').find('.dataTable:first').DataTable();
}


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/utils.js
// module id = 1124
// module chunks = 1